<template>
    <div>
        <!-- 头部组件 -->
        <HeaderPage />
        <div class="container_wrap information">
            <div class="neiBanner">
                <div class="textBanner wow">
                    <dl>INFORMATION DISCLOSURE</dl>
                    <div class="solid"></div>
                    <dt>搜索结果</dt>
                </div>
            </div>
            <div class="box wow">
                <!-- 加载状态 -->
                <div class="loading" v-if="loading">
                    <p>数据加载中...</p>
                </div>
                <!-- 数据列表 -->
                <ul v-else-if="currentPageData.length">
                    <li v-for="(data) in currentPageData" :key="data.id">
                         <router-link :to="`/companynews/detail?type=${data.type}&id=${data.id}`">
                            <h3>{{data.title}}</h3>
                            <ol>
                                <dl>{{ data.datePrefix }}</dl>
                                <span>{{ data.day }}</span>
                            </ol>
                        </router-link>
                    </li>
                </ul>
                <!-- 无数据提示 -->
                <div class="no-data" v-else>暂无数据</div>
            </div>

        </div>

        <!-- 底部组件 -->
        <FooterPage />
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { getWebsiteData } from '@/utils/api'
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'

const route = useRoute()
const currentPageData = ref([])
const loading = ref(false)
const searchTitle = ref('')

// 格式化日期
const formatDate = (dateStr) => {
    if (!dateStr) return { datePrefix: '', day: '' }

    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return {
        datePrefix: `${year}-${month}`,
        day: day
    }
}

// 搜索数据
const searchData = async () => {
    if (!searchTitle.value) return

    loading.value = true
    try {
        const params = {
            title: searchTitle.value,
            pageNo: 1,
            pageSize: 12
        }

        const res = await getWebsiteData(params)

        if (res.data && res.data.list) {
            currentPageData.value = res.data.list.map(item => {
                const dateInfo = formatDate(item.releaseTime)
                return {
                    ...item,
                    datePrefix: dateInfo.datePrefix,
                    day: dateInfo.day
                }
            })
        } else {
            currentPageData.value = []
        }
    } catch (error) {
        console.error('搜索失败：', error)
        currentPageData.value = []
    } finally {
        loading.value = false
    }
}

onMounted(() => {
    // 从URL参数获取搜索关键词
    searchTitle.value = route.query.title || ''
    if (searchTitle.value) {
        searchData()
    }
})

// ✅ 监听 URL 参数变化（如再次搜索跳转）
watch(
  () => route.query.title,
  (newTitle, oldTitle) => {
    if (newTitle !== oldTitle) {
      searchTitle.value = newTitle || ''
      searchData()
    }
  }
)
</script>

<style scoped>
.neiBanner {
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: url('@/assets/images/bg/informationBg.jpg') no-repeat center;
}

.neiBanner .textBanner {
    color: #fff;
    text-align: center;
}

.neiBanner .textBanner dl {
    font-size: 42px;
    color: #003366;
}

.neiBanner .textBanner dt {
    font-size: 30px;
    color: #000;
}

.solid {
    background-color: #003366;
    height: 1px;
    margin: 10px 0;
}

ul {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
}

ul li {
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

ul li:last-child {
    border-bottom: none;
}

ul li a {
    text-decoration: none;
    color: inherit;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

ul li a:hover h3 {
    color: #00437c;
}

ul li h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
    transition: color 0.3s ease;
}

ul li ol {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #666;
    font-size: 14px;
}

.loading {
    text-align: center;
    padding: 50px 0;
    color: #666;
}

.no-data {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
}

.box {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}
</style>
